import { createSlice } from '@reduxjs/toolkit';
import type { Pathway, PathwayState } from './types';

const initialState: PathwayState = {
  isLoading: false,
  error: false,
  pathways: [],
  type: 'owned',
  skills: [],
  index: 0,
  step: 30,
  hasMore: true,
  searchTerm: ''
};

export const slice = createSlice({
  name: 'pathway',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getExploreInitial(state, action) {
      state.isLoading = false;
      state.pathways = [...state.pathways, ...action.payload];
    },
    deletePathwaySuccess(state, action) {
      const idx = state.pathways.map((item) => item.guid).indexOf(action.payload);
      state.pathways = [...state.pathways.slice(0, idx), ...state.pathways.slice(idx + 1)];
    },
    resetPathways(state) {
      state.pathways = [];
    },
    getMyPathways(state, action) {
      const { items, pageIndex } = action.payload as { items: Pathway[]; pageIndex: number };
      if (pageIndex === 0) {
        state.pathways = items;
      } else {
        state.pathways = [...state.pathways, ...items];
      }
      state.isLoading = false;
    },
    getSearchResults(state, action) {
      state.pathways = action.payload;
      state.isLoading = false;
    },
    getAllSkills(state, action) {
      state.skills = action.payload;
      state.isLoading = false;
    },
    getMorePosts(state) {
      const setIndex = state.index + 1;
      state.index = setIndex;
    },
    resetPagination(state) {
      state.index = 0;
      state.step = 30;
      state.hasMore = true;
    },
    noHasMore(state) {
      state.hasMore = false;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const { getMorePosts, resetPagination, setSearchTerm, resetPathways } = slice.actions;
